const Resources = {

    table_headers: [
        { 
          text: 'Cleaning Code',
          align: 'start',
          value: 'name',
        //   type: 'link',
          event: true,
        },
        { 
            text:   'Name',
            value:  'description'
        },
        { 
            text:   'Production standard',
            value:  'production_standard'
        },
        {   
            text:   'Policing',
            value:  'policing',
            type:   'boolean',
        },
        { 
            text:   'Unit',
            value:  'unit',
            type:   'boolean',
        },
        { 
            text:   'Project',
            value:  'project',
            type:   'boolean',
        },
        { 
            text:   'Room Counter',
            value:  'total_rooms',
            type: 'text_link_action',
            sort_type: 'number'
        },
    ],

    validation_table_headers: [
        {
            text: 'Task Name',
            value: 'task_name'
        },
        {
            text: 'Rooms',
            value: 'rooms'
        }
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Tasks',
            href:   '/assignment-tasks',
            arrow:  "",
        },
    ],

    step_table_headers: [
        { 
            name:   'Select',
        },
        {   
            name:   'Step',
        },
        {   
            name:   'Name',
        },
    ],

    excel_file_headers: {
        'Cleaning code': 'name',
        'Name': 'description',
        'Product standard': 'production_standard',
        'Task type': 'special_task_type',
        'Units': 'unit',
    },

    excel_fields_required: {
        name: true,
        description: true,
        production_standard: true,
        special_task_type: false,
        unit: false,
    },

    empty_format_data: [
        {
            name: '',
            description: '',
            production_standard: '',
            special_task_type: '',
            unit: false
        },
    ],

    excel_file_headers_steps: {
        'Task': 'Task',
        'Step Code': 'Step Code'
    },

    empty_format_data_steps: [
        {
            'Task': '',
            'Step Code': '',
        },
    ],

    helps: [
        {
            label: '¿How to add a Task?', 
            instruction: `https://scribehow.com/embed/How_to_Add_a_New_Task__bRlsEtGZQ9GTG3Pha_gTWw?as=scrollable`
        },
        {
            label: '¿How to delete a Task?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Tasks__60nE4bC1QuuIURoLV1rtvg?as=scrollable`
        },
    ],


}

export default Resources;